import { Box } from "@mui/material";
import { useTranslation } from "react-i18next";

import { ErrorLabel } from "./ErrorMessage";

const NoMortgagesMessage = () => {
    const { t } = useTranslation();

    return (
        <Box display={"flex"} alignItems="center" justifyContent="center">
            <ErrorLabel>
                {t("Errors.There are no mortgages to extend. Please contact your client advisor for more details.")}
            </ErrorLabel>
        </Box>
    );
};

export default NoMortgagesMessage;
